import React, { Suspense } from 'react';
import styled from 'styled-components';
import loadable from '@loadable/component'
import { useStaticQuery, graphql } from 'gatsby';


import GlobalStyles from './global-styles';
import Header from './layout/header';

const Background = loadable(() => import('./background'))
// const Background = React.lazy(() => import('./background')) ;

const MainGrid = styled.div``;

const MainContent = styled.main`
  grid-area: content;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: var(--spacer);
  align-self: stretch;
  justify-content: center;

  @media only screen and (min-width: 900px) {
    margin: 0 0 0 16rem;
  }
`;

export default function Layout({ menu = {}, privacy = true, children }) {
  return (
    <MainGrid>
      <GlobalStyles />
      <Background />

      <Header nav={menu} privacy={privacy} />

      <MainContent>{children}</MainContent>
    </MainGrid>
  );
}
